$(function() {
    
    var $Carousel1A = $('.component-carousel-1A__carousel').flickity({
        autoPlay: true,
        pauseAutoPlayOnHover: false,
        imagesLoaded: true,
        percentPosition: false,
        fade: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: false,
        wrapAround: true
    });
    $Carousel1A.on('change.flickity', function(event, index) {
        var $this = $(this);
        var $nav = $this.next();
        var $nav_items = $('.component-carousel-1A__navigation-item', $nav);
        var $nav_item = $($('.component-carousel-1A__navigation-item', $nav)[index]);
        $nav_items.removeClass('active');
        $nav_item.addClass('active');
    });
    $Carousel1A.on('pointerUp.flickity', function() {
       $(this).data('flickity').playPlayer();
    });
    $Carousel1A.on('settle.flickity', function () {
        $(this).data('flickity').playPlayer();
    });

    $('.component-carousel-1A__navigation-item', '.component-carousel-1A').on('click', function() {
        var $this = $(this);
        var index = $this.index();
        $Carousel1A.flickity('select', index);
    });

    //carousels & carousel events
    //var $studentTestimoniesCarousel = new Flickity($('.component-m14-featured-people-carousel-container')[0], { cellAlign:'center', pageDots:false, prevNextButtons: false });
    /*var $componentM14FeaturedPeopleCarousel = $('.component-m14-featured-people-carousel-container').flickity({ cellAlign:'left', pageDots:false, prevNextButtons: false, groupCells: '90%', selectedAttraction: 0.01, friction: 0.15, wrapAround: true });
    $('.component-m14-featured-people-carousel-navigation__item--previous').on( 'click', function() { $componentM14FeaturedPeopleCarousel.flickity('previous'); });
    $('.component-m14-featured-people-carousel-navigation__item--next').on( 'click', function() { $componentM14FeaturedPeopleCarousel.flickity('next'); });

    $(window).on('resize', function() {

        //console.log($(window).width());
        if($(window).width() >= 992) {
            $componentM14FeaturedPeopleCarousel.flickity({groupCells: '100%'});
        }
        //console.log(123);
    });*/
});
